import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import "./AddCircular.css";

const API_URL = "https://aadyaacademy.org/api";

const AddCircular = ({ closeForm, circular }) => {
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [category, setCategory] = useState("");
  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/circular-categories`);
        setCategories(response.data);
      } catch (error) {
        toast.error("Failed to load categories.");
      }
    };

    const fetchCircularDetails = async () => {
      if (circular && circular.id) {
        try {
          const response = await axios.get(`${API_URL}/circulars/${circular.id}`);
          const data = response.data;
          setTitle(data.title || "");
          setDetails(data.description || "");
          setCategory(data.category || "");
          setFromdate(data.fromdate ? new Date(data.fromdate).toISOString().split('T')[0] : '');
          setTodate(data.todate ? new Date(data.todate).toISOString().split('T')[0] : '');
          setPdfUrl(data.pdf_file_path || null);
        } catch (error) {
          toast.error("Failed to fetch circular details.");
        }
      }
    };

    const initializeData = async () => {
      setLoading(true);
      await fetchCategories();
      await fetchCircularDetails();
      setLoading(false);
    };

    initializeData();
  }, [circular]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", details);
    formData.append("category", category);
    formData.append("fromdate", fromdate);
    formData.append("todate", todate);
    if (attachment) {
      formData.append("attachment", attachment);
    } else if (pdfUrl) {
      formData.append("pdf_file_path", pdfUrl);
    }

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    try {
      if (circular) {
        await axios.put(`${API_URL}/circulars/${circular.id}`, formData, config);
        toast.success("✅ Circular updated successfully!", { autoClose: 3000 });
      } else {
        await axios.post(`${API_URL}/circulars`, formData, config);
        toast.success("✅ Circular added successfully!", { autoClose: 3000 });
      }

      setTimeout(() => {
        closeForm();
      }, 1000); // Delay to allow toast to show
    } catch (error) {
      toast.error(error.response?.data?.error || "❌ Failed to add/update circular.", {
        autoClose: 4000,
      });
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="add-circular-container">
      <div className="add-circular-content">
        <h2>{circular ? "Edit Circular" : "Add New Circular"}</h2>
        <form onSubmit={handleFormSubmit}>
          <div className="form-group-Title">
            <h4>Circular Title</h4>
            <input
              type="text"
              placeholder="Enter"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>
          <div className="form-group-Details">
            <h4>Circular Details</h4>
            <textarea
              placeholder="Enter"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              required
            />
          </div>
          <div className="form-group-btm">
            <div className="form-group-Category">
              <h4>Category</h4>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group-Dates">
              <div className="form-group-Date">
                <h4>From Date</h4>
                <input
                  type="date"
                  value={fromdate}
                  onChange={(e) => setFromdate(e.target.value)}
                  required
                />
              </div>
              <div className="form-group-Date">
                <h4>To Date</h4>
                <input
                  type="date"
                  value={todate}
                  onChange={(e) => setTodate(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>
          <div className="form-group-File">
            <h4>Upload PDF File</h4>
            <input
              type="file"
              accept=".pdf"
              onChange={(e) => setAttachment(e.target.files[0])}
            />
            {attachment && <p>Uploaded File: {attachment.name}</p>}
            {pdfUrl && !attachment && (
              <p>
                Existing PDF:{" "}
                <a href={`${API_URL}/${pdfUrl.replace('https://aadyaacademy.org/', '')}`} target="_blank" rel="noopener noreferrer">
                  Open Circular PDF
                </a>
              </p>
            )}
          </div>
          <div className="form-buttons">
            <button className="form-buttons-submit" type="submit">
              Submit
            </button>
            <button
              className="form-buttons-cancel"
              type="button"
              onClick={closeForm}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>

      {/* Ensure ToastContainer is included */}
      <ToastContainer position="top-right" pauseOnHover autoClose={3000} />
    </div>
  );
};

export default AddCircular;
